
import './input-slider.scss';
import React, { HTMLProps, forwardRef, useImperativeHandle, useState } from 'react'

interface InputSliderInterface extends HTMLProps<HTMLInputElement> {
  max?: number;
  min?: number;
  minLabel?: string;
  maxLabel?: string;
  initialValue?: number;
}

const InputSlider = ({ value = 0, ...props }: InputSliderInterface) => {
  return (
    <div className='polymer-input-slider'>
      <div className='polymer-input-slider__label'>
        {props.minLabel && <div className='polymer-input-slider__label-item polymer-input-slider__label-start'>
          {props.minLabel && <p>{props.minLabel}</p>}
          <p>{props.min}</p>
        </div>}
        {props.maxLabel && <div className={props.minLabel ? `polymer-input-slider__label-item polymer-input-slider__label-end` : `polymer-input-slider__label-item polymer-input-slider__label-row`}>
          {props.maxLabel && <p>{props.maxLabel}</p>}
          <p>{props.max}</p>
        </div>}
      </div>
      <input value={value} step={0.1} type='range' min={props.min} max={props.max} onChange={props.onChange} />
    </div>
  )
}

export default InputSlider